// src/index.js

import _dateIomoment from '@date-io/moment';
import { Editor } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import { TableKit } from '@tiptap/extension-table';
import * as tiptapExtensions from 'tiptap-extensions';
import Image from '@tiptap/extension-image';
import TextAlign from '@tiptap/extension-text-align';

// 홈페이지에서 사용할 객체들을 export
export const tiptap = {
    Editor,
    StarterKit,
    tiptapExtensions,
    tiptapTableKit: TableKit,
    Image,
    TextAlign
};

export const dateIomoment = _dateIomoment;